// Formatea un monto con separador de miles (coma) y 2 decimales fijos,
// SIN símbolo de moneda — para usar junto al símbolo/código que cada
// pantalla ya arma por su cuenta (getCurrencySymbol + monto + moneda).
// Ej: formatAmount(3000000) -> "3,000,000.00"
export const formatAmount = (amount) => {
  const num = Number(amount);
  if (amount === null || amount === undefined || isNaN(num)) {
    return '0.00';
  }
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatCurrency = (amount) => {
  // Check if amount is a valid number before formatting
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '$0.00'; // Return a default value for invalid numbers
  }
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

export const formatDate = (date) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(date));
};

export const formatNumber = (number) => {
  // Check if value is a valid number
  if (number === null || number === undefined || isNaN(number)) {
    return '0'; // Return a default value for invalid numbers
  }
  
  return new Intl.NumberFormat('en-US').format(number);
};

export const formatPercentage = (percentage) => {
  // Check if value is a valid number
  if (percentage === null || percentage === undefined || isNaN(percentage)) {
    return '0.00%'; // Return a default value for invalid percentages
  }
  
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 2,
  }).format(percentage);
};
